import {Box, HBox} from '@buncha/components/core/view';
import {Dimensions, StyleSheet} from 'react-native';

import {ChatModes} from '@buncha/batchDetails/types/Chat';
import ChatOpener from '@buncha/components/composites/ChatOpener';
import {H6Text} from '../../../../components/core/text';
import {Modules} from '@buncha/utils/types';
import React from 'react';
import {ShopperScreens} from '@buncha/home/navigation/types';
import {UserTypes} from '@buncha/onBoarding/types';
import {useColorThemeType} from '@buncha/appStyles/hooks/theme';
import {useGetLocale} from '@buncha/localization/hooks';
import {useIsFocused} from '@react-navigation/native';

interface AdjacentOOSChatProps {
  conversationId: string;
  runId?: number;
}

const AdjacentOOSChat = (props: AdjacentOOSChatProps) => {
  const theme = useColorThemeType('main');
  const isFocus = useIsFocused();
  const {body} =
    useGetLocale(Modules.itemDetails, ShopperScreens.ItemDetails) ?? {};

  return (
    <HBox
      style={[
        styles.parentBox,
        {backgroundColor: theme?.background.yellow[200]},
      ]}>
      <H6Text style={[styles.ItemNameTypo, {color: theme?.text.blue[300]}]}>
        {body?.coShopperIsShopping}
      </H6Text>
      <Box style={styles.chatBox}>
        <ChatOpener
          hideRole={UserTypes.driver}
          mode={ChatModes.order}
          conversationId={props?.conversationId}
          runId={isFocus ? props?.runId : undefined}
          height={30}
          style={styles.chatIcon}
        />
      </Box>
    </HBox>
  );
};

export default React.memo(AdjacentOOSChat);

const styles = StyleSheet.create({
  ItemNameTypo: {
    textAlign: 'left',
    flex: 1,
    marginLeft: 10,
  },
  parentBox: {
    marginTop: 0,
    paddingHorizontal: 10,
    paddingVertical: 0,
    marginBottom: 10,
    flex: 1,
    maxWidth: Dimensions.get('screen').width,
  },
  chatBox: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  chatIcon: {
    marginTop: 0,
    paddingBottom: 6,
  },
});
